export default {
  computed: {
    payVip: function payVip() {
      return this.$store.state.payVip;
    },
    $isLogin: function $isLogin() {
      return this.$store.state.isLogin;
    },
    userInfo: function userInfo() {
      return this.$store.state.userInfo;
    },
    pageReady: function pageReady() {
      return this.$store.state.payVipUserInfoPromise;
    },
    isInApp: function isInApp() {
      return this.$store.state.isInApp;
    },
    deviceSize: function deviceSize() {
      return this.$store.state.deviceSize;
    }
  },
  methods: {
    getLevelDisplay: function getLevelDisplay(level) {
      return level === 8 ? '星光' : 'V' + level;
    }
  }
};